import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Stack, IconButton, InputAdornment, TextField, Button, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import Iconify from '../../../components/iconify';
import Logo from 'src/components/logo/crm-logo.avif';
import { postData } from 'src/webService/webService';
import { toast } from 'react-toastify';

export default function LoginForm() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [roleType, setRoleType] = useState('');
  const [specificRole, setSpecificRole] = useState('');

  sessionStorage.setItem('role', role);

  const handleLogin = async () => {
    debugger;
    const loginData = {
      email: username,
      password: password,
      role: role,
      roleType: roleType,
      ...(role !== 'Sales' && { serviceTeamType: specificRole }),
    };
    

    try {
      const response = await postData('users/login', loginData);
      console.log('Login successful:', response);
      if (response?.status === 200) {
        sessionStorage.setItem('Token', response?.data?.sessionToken);
        sessionStorage.setItem('role', role);
        sessionStorage.setItem('roleType', roleType);
        if (role !== 'Sales') {
          sessionStorage.setItem('serviceTeamType', specificRole);
        }
        sessionStorage.setItem('userId', response?.data?.userId);
        navigate(`/${role.toLowerCase()}/dashboard/app`, { replace: true });
        toast.success('Login Successfully!')
      }
    } catch (error) {
      console.error('Login Error:', error);
      toast.error('Login failed. Please check your credentials.');
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#ffc860',
        borderTopLeftRadius: '15px',
        borderBottomLeftRadius: '20px',
      }}
    >
      <Box sx={{ textAlign: 'center', width: '320px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={Logo} alt='Logo' style={{ maxWidth: '35%', borderRadius: '15px', marginBottom: '25px', marginTop: '50px' }} />
        </Box>
        <Stack spacing={2} alignItems='center'>
          <TextField
            fullWidth
            placeholder='Enter Your Email'
            size='small'
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            sx={{ width: '250px', backgroundColor: 'white', borderRadius: '12px' }}
          />

          <TextField
            fullWidth
            placeholder='Enter Your Password'
            size='small'
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ width: '250px', backgroundColor: 'white', borderRadius: '12px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <FormControl sx={{ width: '250px', backgroundColor: 'white', borderRadius: '12px' }}>
            <InputLabel>Select Role</InputLabel>
            <Select label="Select Role" value={role} onChange={(e) => { setRole(e.target.value); setRoleType(''); setSpecificRole(''); }}>
              <MenuItem value='Admin'>Admin</MenuItem>
              <MenuItem value='Sales'>Sales</MenuItem>
              <MenuItem value='Service'>Service</MenuItem>
            </Select>
          </FormControl>

          {/* Conditional roleType Dropdown for Sales */}
          {role === 'Sales' && (
            <FormControl sx={{ width: '250px', backgroundColor: 'white', borderRadius: '12px' }}>
              <InputLabel>Select SubRole</InputLabel>
              <Select label="Select SubRole" value={roleType} onChange={(e) => setRoleType(e.target.value)}>
                <MenuItem value='Team Leader'>Team Leader</MenuItem>
                <MenuItem value='Employee'>Employee</MenuItem>
              </Select>
            </FormControl>
          )}

          {/* Conditional Specific Role Dropdown for Service */}
          {role === 'Service' && (
            <>
              <FormControl sx={{ width: '250px', backgroundColor: 'white', borderRadius: '12px' }}>
                <InputLabel>Select Service Type</InputLabel>
                <Select label="Select Service Type" value={specificRole} onChange={(e) => setSpecificRole(e.target.value)}>
                  <MenuItem value='SEO'>SEO</MenuItem>
                  <MenuItem value='WebSite Designing'>Website Designing</MenuItem>
                  <MenuItem value='Content Creation'>Content Creation</MenuItem>
                  <MenuItem value='Camera Man'>Camera Man</MenuItem>
                  <MenuItem value='Video Editing'>Video Editing</MenuItem>
                  <MenuItem value='Graphic Designing'>Graphic Designing</MenuItem>
                  <MenuItem value='Social Media'>Social Media</MenuItem>
                </Select>
              </FormControl>
              {specificRole && (
                <FormControl sx={{ width: '250px', backgroundColor: 'white', borderRadius: '12px' }}>
                  <InputLabel>Select SubRole</InputLabel>
                  <Select label="Select SubRole" value={roleType} onChange={(e) => setRoleType(e.target.value)}>
                    <MenuItem value='Team Leader'>Team Leader</MenuItem>
                    <MenuItem value='Employee'>Employee</MenuItem>
                  </Select>
                </FormControl>
              )}
            </>
          )}

          <Button
            fullWidth
            variant='contained'
            onClick={handleLogin}
            sx={{ width: '125px', backgroundColor: 'black', color: 'white', borderRadius: '30px' }}
          >
            Login
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
